import { create } from 'zustand';
import type { NpcPublicDTO } from '@hexcrawl/shared-utils';

interface NpcStoreState {
  npcs: Record<string, NpcPublicDTO>;
  setNpc: (npc: NpcPublicDTO) => void;
  setNpcs: (npcs: NpcPublicDTO[]) => void;
  removeNpc: (id: string) => void;
  clear: () => void;
}

export const useNpcStore = create<NpcStoreState>()((set) => ({
  npcs: {},
  setNpc: (npc) => set((s) => ({ npcs: { ...s.npcs, [npc.id]: npc } })),
  setNpcs: (npcs) => set((s) => {
    const updated = { ...s.npcs };
    for (const npc of npcs) updated[npc.id] = npc;
    return { npcs: updated };
  }),
  removeNpc: (id) => set((s) => {
    const { [id]: _removed, ...rest } = s.npcs;
    return { npcs: rest };
  }),
  clear: () => set({ npcs: {} }),
}));
